import type { AnalyticsMetadata } from "@/services/analytics-service";

import type { AuthMetadata } from "./types";

export const mapAnalyticsToAuthMetadata = (
  analytics: Partial<AnalyticsMetadata>,
): AuthMetadata => {
  return {
    utm_source: analytics.utm_source,
    utm_medium: analytics.utm_medium,
    utm_campaign: analytics.utm_campaign,
    utm_content: analytics.utm_content,
    utm_term: analytics.utm_term,
    utm_spot: analytics.utm_spot,
    utm_sub_spot: analytics.utm_sub_spot,
    utm_custom: analytics.utm_custom,
    utm_origin: analytics.utm_origin,
    click_id: analytics.click_id,
    browser_id: analytics._fbp,
    fbc: analytics._fbc,
    ab_test: analytics.up_ab_test,
  };
};
